import { useEffect } from 'react';

function PublicFlowEntry() {
  useEffect(() => {
    const currentParams = new URLSearchParams(window.location.search);
    const flow = currentParams.get('flow') || 'booking_first';
    const normalizedParams = new URLSearchParams(currentParams.toString());

    normalizedParams.set('public_booking', 'true');

    if (normalizedParams.get('clinic_id')) {
      normalizedParams.set('lock_clinic', 'true');
    }

    if (flow === 'booking_first') {
      normalizedParams.set('booking_first', 'true');
    } else {
      normalizedParams.delete('booking_first');
    }

    normalizedParams.delete('flow');

    const targetPath = flow === 'assessment_first' ? '/virtual_consultation' : '/public/booking';
    const targetQuery = normalizedParams.toString();
    window.location.replace(targetQuery ? `${targetPath}?${targetQuery}` : targetPath);
  }, []);

  return null;
}

export default PublicFlowEntry;